type Props = {
  lessonNumber?: string | number
  lessonTitle: string
}

const RescheduleModalTitle = ({ lessonNumber, lessonTitle }: Props) => (
  <p className="text-xl leading-tight font-600">
    You are rescheduling Lesson{lessonNumber && ` ${lessonNumber}`}:{' '}
    {lessonTitle}
  </p>
)

export default RescheduleModalTitle
